import { useFormContext } from 'react-hook-form';
import ErrorMessage from 'components/ui/ErrorMessage/ErrorMessage';
import { Box } from 'components/primitives/box';
import BookingAgreement from './BookingAgreement';
import SubmitButton from '../../forms/SubmitButton';

const OwnerPreApproveContent = ({ hideModal, specialOffer, insuranceType, approve, booking }) => {
  const { register, errors } = useFormContext();

  const getText = () => {
    if (specialOffer) {
      return 'Send special offer';
    }
    if (approve) {
      return 'Approve booking';
    }
    return 'Pre-approve booking';
  };

  return (
    <div>
      <div>
        {specialOffer && (
          <div className="Grid Grid--alignMiddle">
            <div className="Grid-cell remodalTraySpacingMobile">
              <div className="u-fsBase u-textBold u-mb1">Special price</div>
            </div>
            <div className="Grid-cell">
              <div className="Grid Grid--withGutter">
                <div className="Grid-cell u-size1of2 u-sm-sizeFull">
                  <div className="u-textCenter u-mb2">
                    <div
                      className={` ${
                        errors.special_offer_price ? ' is-invalid' : ''
                      } Arrange Arrange--middle InputWithAddon`}
                    >
                      <div className="Arrange-sizeFit">
                        <div className="InputAddOn InputAddOn--prefix">$</div>
                      </div>
                      <div className="Arrange-sizeFill">
                        <input
                          className="InputText InputText--withPrefix u-sizeFull"
                          type="number"
                          name="special_offer_price"
                          data-testid="conversation_booking_special_price"
                          id="conversation_booking_special_price"
                          placeholder="Enter boat price"
                          ref={register({
                            validate: (value) => !!value,
                            pattern: /^[0-9]*$/,
                          })}
                        />
                      </div>
                    </div>
                    <ErrorMessage
                      className="u-textRight"
                      error={errors.special_offer_price}
                      message={
                        errors.special_offer_price && errors.special_offer_price.type === 'pattern'
                          ? 'Please round to the nearest dollar amount.'
                          : 'Required '
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="Grid Grid--alignMiddle">
          <div className="Grid-cell">
            <div className="u-fsBase u-textBold u-mb1">Pickup Instructions</div>
          </div>
          <div className="Grid-cell">
            <Box position="relative">
              <textarea
                className="Textarea Textarea--owners u-sizeFull"
                name="pickup_instructions"
                data-testid="pickup_instructions"
                rows={5}
                defaultValue="Pick up at dock"
                ref={register({ required: true })}
              />
            </Box>
            <div className="u-mb2">
              <div className="u-fsTiny">Specify pickup instructions to renter</div>
              <ErrorMessage error={errors.pickup_instructions} message="Required." />
            </div>
          </div>
        </div>
        <BookingAgreement userType="owner" booking={booking} insuranceType={insuranceType} />
        <div className="Grid Grid--withGutter">
          <div className="Grid-cell u-size1of2 u-sm-sizeFull">
            <div className="Grid Grid--withGutter" data-testid="components-modals-owner-approve-or-cancel-box">
              <div className="Grid-cell u-size2of3 u-sm-sizeFull u-sm-mb1">
                <SubmitButton disabled={false} additionalClasses="Button--yellow u-sizeFull u-sm-mb1">
                  {getText()}
                </SubmitButton>
              </div>
              <div className="Grid-cell u-size1of3 u-sm-sizeFull">
                <button onClick={hideModal} type="button" className="Button u-fsSm Button--ownersOutline u-sizeFull">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerPreApproveContent;
